import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.path ? `https://91n-guide.com${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && <i className="ri-arrow-right-s-line text-xs"></i>}
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}

export function getCategoryBreadcrumb(slug: string, pageTitle?: string): BreadcrumbItem[] {
  const category = categories.find((c) => c.slug === slug);
  const items: BreadcrumbItem[] = [
    { label: '首页', path: '/' },
  ];
  if (category) {
    items.push({ label: category.name, path: `/category/${slug}` });
  }
  if (pageTitle) {
    items.push({ label: pageTitle });
  }
  return items;
}